let cookieState = "false"
let cookieStateBtn = "false"
let cookieStateFb = "false"
let cookieButtonSettings = document.getElementById('cookie-button-settings')
let cookieButtonAccept = document.getElementById('cookie-button-accept')
let cookieButtonDeny = document.getElementById('cookie-button-deny')
let cookieContent = document.getElementById('cookie-content')
let cookieButtonFacebookPagePlugin = document.getElementById('show-facebook-page-plugin')

/**
 * save cookie decision to local storage
 */
function saveCookieDecisionToLocalStorage(newState) {
    if (newState === true) {
        localStorage.setItem('pixelparker_web_cookie_accept', JSON.stringify('true'))
        localStorage.setItem('pixelparker_web_cookie', JSON.stringify('true'))
        readAndCheckCookieDecisionFromLocalStorage()
    } else if (newState === false) {
        localStorage.setItem('pixelparker_web_cookie_accept', JSON.stringify('false'))
        localStorage.setItem('pixelparker_fb_cookie', JSON.stringify('false'))
        localStorage.setItem('pixelparker_web_cookie', JSON.stringify('true'))
        readAndCheckCookieDecisionFromLocalStorage()
    }
}

/**
 * read and check cookie decision from local storage
 */
function readAndCheckCookieDecisionFromLocalStorage() {
    cookieStateBtn = JSON.parse(localStorage.getItem('pixelparker_web_cookie'))
    cookieState = JSON.parse(localStorage.getItem('pixelparker_web_cookie_accept'))
    cookieStateFb = JSON.parse(localStorage.getItem('pixelparker_fb_cookie'))
    console.log("1:", cookieState, " 2: ", cookieStateFb, " 3: ", cookieStateBtn)
    reactOnState()
}

/**
 * show cookie Settings
 */
function showCookieSettings() {
    cookieContent.classList.toggle('d-flex')
    cookieContent.classList.toggle('d-none')
}

/**
 * show facebook page plugin
 */
let facebookPagePluginOverlay = document.getElementById('facebook-page-plugin-overlay')
let facebookPagePlugin = document.getElementById('facebook-page-plugin')
function showFacebookPagePlugin() {
    localStorage.setItem('pixelparker_fb_cookie', JSON.stringify('true'))
    facebookPagePluginOverlay.classList.toggle('d-flex')
    facebookPagePluginOverlay.classList.toggle('d-none')
    facebookPagePlugin.classList.toggle('d-none')
    facebookPagePlugin.classList.toggle('d-flex')
}


/**
 * react on state -> show or hide content
 */
function reactOnState() {
    if (cookieStateBtn === "true") {
        cookieContent.classList.add('d-none')
        cookieContent.classList.remove('d-flex')
    } else if (cookieStateBtn === "false") {
        cookieContent.classList.add('d-flex')
        cookieContent.classList.remove('d-none')
    }

    if (cookieStateFb === "true") {
        facebookPagePluginOverlay.classList.add('d-none')
        facebookPagePluginOverlay.classList.remove('d-flex')
        facebookPagePlugin.classList.add('d-flex')
        facebookPagePlugin.classList.remove('d-none')
    } else if (cookieStateFb === "false") {
        facebookPagePluginOverlay.classList.add('d-flex')
        facebookPagePluginOverlay.classList.remove('d-none')
        facebookPagePlugin.classList.add('d-none')
        facebookPagePlugin.classList.remove('d-flex')
    }
}

/**
 * cookie button click event
 */
cookieButtonAccept.addEventListener('click', function () {
    saveCookieDecisionToLocalStorage(true)
})
cookieButtonDeny.addEventListener('click', function () {
    saveCookieDecisionToLocalStorage(false)
})
cookieButtonSettings.addEventListener('click', function () {
    showCookieSettings()
})

if (cookieButtonFacebookPagePlugin) {
    cookieButtonFacebookPagePlugin.addEventListener('click', function () {
        showFacebookPagePlugin()
    })
}


/**
 * document content loaded function
 */
document.addEventListener('DOMContentLoaded', function () {
    readAndCheckCookieDecisionFromLocalStorage()
})
